var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessTabCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Success Checkmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.25C17.5228 22.25 22 17.7728 22 12.25C22 6.72715 17.5228 2.25 12 2.25C6.47715 2.25 2 6.72715 2 12.25C2 17.7728 6.47715 22.25 12 22.25ZM16.592 9.71049C16.8463 9.38353 16.7874 8.91232 16.4605 8.65802C16.1335 8.40372 15.6623 8.46262 15.408 8.78958L11.401 13.9414C11.3119 14.056 11.1443 14.0709 11.0364 13.9738L8.50173 11.6926C8.19385 11.4155 7.71963 11.4404 7.44254 11.7483C7.16544 12.0562 7.1904 12.5304 7.49828 12.8075L10.033 15.0887C10.7881 15.7683 11.9613 15.6643 12.585 14.8623L16.592 9.71049Z",
    fill: "#298700"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTabCheckmark);
export default __webpack_public_path__ + "static/media/Success_tab_Checkmark.e67fc807165b952355c57be71c18aced.svg";
export { ForwardRef as ReactComponent };